<style scoped lang="scss" type="text/scss">
    .special-competition-container {
        .special-competition-items {
            margin: -1rem 0 0 -1rem;
            display: flex;
            flex-wrap: wrap;

            .special-competition-item {
                height: 9rem;
                margin: 1rem 0 0 1rem;
                width: calc(50% - 1rem);
            }
        }
    }
</style>

<template>
    <div class="special-competition-container">
        <block-divider>单项赛</block-divider>
        <placeholder v-if="specialCompetitions.length === 0">暂无可报名的单项赛</placeholder>
        <div class="special-competition-items" v-else>
            <special-competition-item class="special-competition-item"
                                      v-for="(specialCompetition, index) in specialCompetitions" :key="index"
                                      :editable="true" :info="specialCompetition" :index="index + 1"
                                      @need-reload="loadPlayerSpecialCompetitions"
            >
            </special-competition-item>
        </div>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../components/divider/block';
    import SpecialCompetitionItem from '../../../../sub-components/special-competition-item/index';
    import Placeholder from '../../../../../components/placeholder/index';
    import {mapState} from 'vuex';

    export default {
        name: '',
        components: {
            BlockDivider,
            SpecialCompetitionItem,
            Placeholder
        },
        data () {
            return {};
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId,
                specialCompetitions: state => state.currentManagedPlayerSpecialCompetitions
            })
        },
        watch: {
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.loadPlayerSpecialCompetitions();
                }
            }
        },
        methods: {
            loadPlayerSpecialCompetitions () {
                return this.$store.dispatch('player/loadSpecialCompetitions', {
                    id: this.currentManagedPlayerId
                }).then(response => {
                }).catch(_ => {
                });
            }
        }
    };
</script>
